import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrivacyPolicyComponent} from './privacy-policy.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PrivacyPolicyComponent],
  exports: [PrivacyPolicyComponent]
})
export class PrivacyPolicyModule {
}



// WEBPACK FOOTER //
// ./src/app/components/privacy-policy/privacy-policy.module.ts